// import { replace } from "core-js/fn/symbol";

import { RockObject } from "./rockObject";

export default {
  /**
   * @returns {Object} of all Minerals in the appropriate language
   */
  async getAllRocks(context) {
    const currentLanguage = this.state.language.currentLanguage;
    const dictionary = this.state.language.rockGlossary;

    let results = await this.state.rocks.rockDatabase.map(
      (roc) => new RockObject(currentLanguage, dictionary, roc),
    );

    results.sort((a, b) => a.name.propValue.localeCompare(b.name.propValue));
    context.commit("displayNoMatch", false);
    context.commit("getAllRocks", results);
  },
  async getOneRock(context, payload) {
    const data = this.state.rocks.rockDatabase;
    const dictionary = this.state.language.rockGlossary;
    const languageId = this.state.language.currentLanguage;

    // if the language is portuguese, use collator to sort
    const collator = new Intl.Collator(languageId, {
      usage: "search",
      sensitivity: "base",
    });
    let match;
    if (languageId === "pt") {
      match = await data.find(
        (dat) => collator.compare(dat[languageId + "_name"], payload) === 0,
      );
    } else {
      match = await data.find(
        (dat) => collator.compare(dat.name, payload) === 0,
      );
    }

    if (!match) {
      context.commit("displayNoMatch", true);
    } else {
      // targetLanguage, data, dictionary, rock, sourceLanguage = null
      const results = new RockObject(languageId, dictionary, match);
      context.commit("displayNoMatch", false);
      context.commit("getAllRocks", [results]);
    }
  },

  getPageTitle(context) {
    const currentLanguage = this.state.language.currentLanguage;
    context.commit("getPageTitle", currentLanguage);
  },
  /**
   *
   * @param {String} payload of letter typed by user in the input
   * @returns {Array} querySuggestions of mineral names that matches the payload
   */
  async getQuerySuggestions(context, payload) {
    let reg = new RegExp(`\\b${payload}`, "i");
    // rockNameArray cannot include null values, or the match method will return uncaught type error

    const currentLanguage = this.state.language.currentLanguage;

    let rockNameArray;
    if (currentLanguage === "en") {
      rockNameArray = await this.state.rocks.rockDatabase.map((r) => r.name);
    }
    if (currentLanguage === "pt") {
      rockNameArray = await this.state.rocks.rockDatabase.map((r) => r.pt_name);
    }

    const querySuggestions = await rockNameArray.filter((el) => el.match(reg));

    context.commit("getQuerySuggestions", querySuggestions);
  },
  /**
   *
   * @returns {Array} with mineral names in the user language
   */
  async getRockNames(context) {
    const currentLanguage = this.state.language.currentLanguage;

    let rockNames;

    if (currentLanguage === "pt") {
      rockNames = await this.state.rocks.rockDatabase
        .map((el) => el.pt_name)
        .sort();

      return context.commit("getRockNames", rockNames);
    }

    rockNames = await this.state.rocks.rockDatabase.map((el) => el.name).sort();

    context.commit("getRockNames", rockNames);
  },
  /**
   *
   * @param {String} payload with rock type: igneous, sedimentary, or metamorphic
   * @returns {Array } of objects with the rocks that fit the selected type
   */
  async getRockType(context, payload) {
    const currentLanguage = this.state.language.currentLanguage;
    const dictionary = this.state.language.rockGlossary;
    let condition;
    condition = payload.substring(1, 4);

    const filteredResults = await this.state.rocks.rockDatabase.filter(
      (rock) => {
        return rock.type.includes(condition);
      },
    );

    const results = filteredResults.map(
      (pr) => new RockObject(currentLanguage, dictionary, pr),
    );

    context.commit("getAllRocks", results);
  },
  async getRockFromParams(context, payload) {
    const rockName = payload;

    const data = await this.state.rocks.rockDatabase;
    const dictionary = this.state.language.rockGlossary;
    const languageId = this.state.language.currentLanguage;

    const removeAccent = function (str) {
      return str
        .normalize("NFD")
        .replace(/([\u0300-\u036f]|[^a-zA-Z])|\W/g, "")
        .toLowerCase();
    };

    const match = data.filter((r) => removeAccent(r.name) === rockName);
    if (match.length === 0) {
      context.commit("displayNoMatch", true);
    }

    if (match.length > 0) {
      const results = new RockObject(languageId, dictionary, match[0]);
      context.commit("getOneRock", results);
      context.commit("displayNoMatch", false);
    }
  },
};
